import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { Suspense, lazy, memo } from "react";
import { mergeSx } from "../system";
const AntiguaAndBarbuda = lazy(() => import("../icons/flags/AntiguaAndBarbuda"));
const Argentina = lazy(() => import("../icons/flags/Argentina"));
const Aruba = lazy(() => import("../icons/flags/Aruba"));
const Bahamas = lazy(() => import("../icons/flags/Bahamas"));
const Barbados = lazy(() => import("../icons/flags/Barbados"));
const Belize = lazy(() => import("../icons/flags/Belize"));
const Bolivia = lazy(() => import("../icons/flags/Bolivia"));
const Brazil = lazy(() => import("../icons/flags/Brazil"));
const Canada = lazy(() => import("../icons/flags/Canada"));
const Chile = lazy(() => import("../icons/flags/Chile"));
const Colombia = lazy(() => import("../icons/flags/Colombia"));
const CostaRica = lazy(() => import("../icons/flags/CostaRica"));
const Cuba = lazy(() => import("../icons/flags/Cuba"));
const Curaçao = lazy(() => import("../icons/flags/Curaçao"));
const Dominica = lazy(() => import("../icons/flags/Dominica"));
const DominicanRepublic = lazy(() => import("../icons/flags/DominicanRepublic"));
const Ecuador = lazy(() => import("../icons/flags/Ecuador"));
const ElSalvador = lazy(() => import("../icons/flags/ElSalvador"));
const Grenada = lazy(() => import("../icons/flags/Grenada"));
const Guatemala = lazy(() => import("../icons/flags/Guatemala"));
const Guyana = lazy(() => import("../icons/flags/Guyana"));
const Haiti = lazy(() => import("../icons/flags/Haiti"));
const Honduras = lazy(() => import("../icons/flags/Honduras"));
const Jamaica = lazy(() => import("../icons/flags/Jamaica"));
const Mexico = lazy(() => import("../icons/flags/Mexico"));
const Nicaragua = lazy(() => import("../icons/flags/Nicaragua"));
const Panama = lazy(() => import("../icons/flags/Panama"));
const Paraguay = lazy(() => import("../icons/flags/Paraguay"));
const Peru = lazy(() => import("../icons/flags/Peru"));
const SaintLucia = lazy(() => import("../icons/flags/SaintLucia"));
const SaintVincentAndTheGrenadines = lazy(() => import("../icons/flags/SaintVincentAndTheGrenadines"));
const SintMaarten = lazy(() => import("../icons/flags/SintMaarten"));
const Suriname = lazy(() => import("../icons/flags/Suriname"));
const TrinidadAndTobago = lazy(() => import("../icons/flags/TrinidadAndTobago"));
const UnitedStatesOfAmerica = lazy(() => import("../icons/flags/UnitedStatesOfAmerica"));
const Uruguay = lazy(() => import("../icons/flags/Uruguay"));
const Venezuela = lazy(() => import("../icons/flags/Venezuela"));
export const countries = {
    antiguaAndBarbuda: AntiguaAndBarbuda,
    argentina: Argentina,
    aruba: Aruba,
    bahamas: Bahamas,
    barbados: Barbados,
    belize: Belize,
    bolivia: Bolivia,
    brazil: Brazil,
    canada: Canada,
    chile: Chile,
    colombia: Colombia,
    costaRica: CostaRica,
    cuba: Cuba,
    curaçao: Curaçao,
    dominica: Dominica,
    dominicanRepublic: DominicanRepublic,
    ecuador: Ecuador,
    elSalvador: ElSalvador,
    grenada: Grenada,
    guatemala: Guatemala,
    guyana: Guyana,
    haiti: Haiti,
    honduras: Honduras,
    jamaica: Jamaica,
    mexico: Mexico,
    nicaragua: Nicaragua,
    panama: Panama,
    paraguay: Paraguay,
    peru: Peru,
    saintLucia: SaintLucia,
    saintVincentAndTheGrenadines: SaintVincentAndTheGrenadines,
    sintMaarten: SintMaarten,
    suriname: Suriname,
    trinidadAndTobago: TrinidadAndTobago,
    unitedStatesOfAmerica: UnitedStatesOfAmerica,
    uruguay: Uruguay,
    venezuela: Venezuela,
};
export const flagClasses = {
    root: "MinervaFlag-root",
};
export const Flag = memo(({ country, size, sx, className, ...props }) => {
    const Country = country ? countries[country] : undefined;
    return Country ? (_jsx(Suspense, { children: _jsx(Country, { sx: mergeSx({ borderRadius: (theme) => theme.radius.full }, sx), size: size, className: clsx([flagClasses.root, className]), ...props }) })) : null;
});
//# sourceMappingURL=Flag.js.map